import Vue from "vue";
import Vuex from "vuex";
import { Loader, AbstractLoadStrategy, Resource, ResourceType }  from "resource-loader";

// New load strategy for video

class VideoLoadStrategy extends AbstractLoadStrategy {
  constructor(config){
    super(config);
  }

  load(){
    //console.log('VIDEO LOAD STRATEGY');
    const config = this.config;
    const urls = config.sourceSet || [config.url];

    this._element = document.createElement('video');
    this._element.style.display = 'none';
    this._element.setAttribute('playsinline', 'true');
    this._element.setAttribute('loop', 'true');
    this._element.setAttribute('crossOrigin', 'anonymous');
    this._element.setAttribute('muted', 'false');

    var req = new XMLHttpRequest();

    req.open('GET', urls[0], true);
    req.responseType = 'blob';
    req.addEventListener('load', (evt) => this._onComplete(evt, req));
    req.addEventListener('error', (evt) => this.abort(evt));
    req.addEventListener('progress', (evt) => this._onProgress(evt, req));
    req.send();
  }

  abort(){

  }

  _onProgress(evt){
    this.onProgress.dispatch(evt.loaded / evt.total);
  }

  _onComplete(evt, req){
    if(req.status === 200) {
      //console.log('VIDEO LOADED!');
      let blob = req.response;
      let url = URL.createObjectURL(blob);
      this._element.src = url;
      //this._element.setAttribute('muted', 'true');
    }

    this.onComplete.dispatch(ResourceType.Video, this._element);
  }
}

Resource.setLoadStrategy('.mp4', VideoLoadStrategy);
Vue.use(Vuex);

export default new Vuex.Store({
  state: {

    // Main app loader

    loader : null,
    resources : {},


    // Loader Events
    loadStart : 0,
    loadProgress : 0,
    loadComplete : 0,

    // App Events (Values used as watched listeners. Will increment whenever dispatched)
    
    back : 0,      //Fires when on screen back button is clicked
    zoomIn : 0,    //Fires when on screen zoomIn button is clicked
    zoomOut : 0,   //Fires when on screen zoomOut button is clicked
    enterRoom : 0, //Fires when a room selection is made
    enterGallery : 0,  //Fires when entering/returning to the gallery
    startRoom:0, //Fires when the room has been entered
    
    transition: '',
    startTransition : 0, //Fires when a transition starts
    endTransition: 0, // Fires when a  transition ends
    
    accelerometerRequest : 0, //Fires when clicking into a scene if accelorometer controls are available


    currentScreen : 'splash',
    environment : {
      platformName : '',
      isAndroid : false,
      isIOS : false,
      isMacOS: false,
      isWindows : false,
      isDesktop : false,
      isMobile : false
    },

    sound : {
      startSound : require('@/assets/audio/empty.mp3')
    },

    screens : {
      splash : {
        title : 'Full Capacity',
        siteLogo: require('@/assets/images/icons/site_logo.svg'),
        subtitle : '',
        content : "Welcome to Alfred Ceramic Art Museum’s first virtual reality exhibition by Guest Curator, Kelcy Chase Folsom.\n\nFour artists, Lisa Marie Barber, Diedrick Brackens, Coco Klockner, and Jeanne Quinn were invited to imagine a new place that exists beyond a painting by Ryan Mrozowski, Untitled (Shifted Flowers). Using descriptions and drawings created by the artists, virtual reality designers from Primal Screen collaborated to build four, distinct virtual worlds. We invite you to explore these spaces now and forever.",
        confirm : 'Enter',
        active : true,
        state : 'default'
      },

      gallery : {
        bg : '@/assets/images/bg/gallery.png',
        image : './assets/images/bg/rayan.png',
        title : 'Ryan Mrozowski - Untitled',
        active : true,
        state : 'zoom'
      },

      menu : {
        confirm : 'Enter',
        active : false,
        state : 'default'
      },

      loader : {
        confirm : 'Enter',
        active : true,
        state : 'default'
      },

      room : {
        active : true,
        state : 'default',
        artist : 'lmb',
        gallery :  {
          pano : require('@/assets/images/textures/gallery.mp4'),
          mobile : require('@/assets/images/textures/mobile/gallery.mp4'),
        } 
      }
    },

    artists : [
      {
        key : 'lmb',
        name : 'Lisa Marie Barber',
        bio : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. \nAt vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.',
        pano : require('@/assets/images/textures/lmb_pano.mp4'),
        mobile : require('@/assets/images/textures/mobile/lmb_pano.mp4'),
        icon : 'MenuButton_LMB.jpg',
        particles : false,
        bgm : "LMB_Garden2_but_with_bird.mp3"
      },
      {
        key : 'db',
        name : 'Diedrick Brackens',
        bio : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. \nAt vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.',
        pano : require('@/assets/images/textures/db_pano.mp4'),
        mobile : require('@/assets/images/textures/mobile/db_pano.mp4'),
        bgm : "db.mp3",
        icon : 'MenuButton_DB.jpg',
        particles : false
      },
      {
        key : 'jq',
        name : 'Jeanne Quinn',
        bio : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. \nAt vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.',
        pano : require('@/assets/images/textures/jq_pano.mp4'),
        mobile : require('@/assets/images/textures/mobile/jq_pano.mp4'),
        icon : 'MenuButton_JQ.jpg',
        bgm : "jq.mp3",
        volume :  0.12,
        particles : false
      },
      {
        key : 'ck',
        name : 'Coco Klockner',
        bio : 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum. \nAt vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae. Itaque earum rerum hic tenetur a sapiente delectus, ut aut reiciendis voluptatibus maiores alias consequatur aut perferendis doloribus asperiores repellat.',
        pano : require('@/assets/images/textures/ck_pano.mp4'),
        mobile : require('@/assets/images/textures/mobile/ck_pano.mp4'),
        icon : 'MenuButton_CK.jpg',
        particles : false,
        bgm : "ACAM-CK-AUDIO-1.mp3"
      }
    ]

  },

  getters : {
    loadProgress(state) {
      let v = 0;
      if(state.loader){
        let resources = state.loader.resources;

        for(var k in resources) {
          let resource = resources[k];
          v += resource.progressChunk;
        }
        
      }

      return v;
    }
  },

  mutations: {
    load(state, {assets, onStart, onLoad, onProgress, onComplete, onError}) {
      state.loader = new Loader();
      assets.forEach(url => {
        if(!state.resources[url]) state.loader.add(url);
      });

      

      state.loader.onStart.add(() => {
        state.loadStart = Date.now();
        for(var k in state.loader.resources) {
          let resource = state.loader.resources[k];
          resource.onProgress.add((r,p) => {
            state.loadProgress = state.loader.progress + p * 100;
          })
        }
      });
      state.loader.onProgress.add(() => state.loadProgress = state.loader.progress);
      state.loader.onComplete.add(() => state.loadComplete = Date.now());

      if(onStart) state.loader.onStart.add(onStart);
      if(onLoad) state.loader.onLoad.add(onLoad);
      if(onProgress) state.loader.onProgress.add(onProgress);
      if(onError) state.loader.onError.add(onError);

      state.loader.use((r,next) => {
        console.log(r);
        //Happpens on each resource after load
        next();
      })
      .load( (l, resources) => {
        console.log(resources);
        for(var k in resources) {
          state.resources[k] = resources[k];
        }

        if(onComplete) onComplete();
      });

    },

    hide(state, name) {
      let screen = state.screens[name];
      if(screen){
        screen.active = false;
      }
    },

    show(state, name) {
      let screen = state.screens[name];
      if(screen){
        screen.active = true;
      }
    },

    setState(s, {name, state}) {
      let screen = s.screens[name];
      if(screen){
        console.log('SETTING STATE', name, state);
        screen.state = state;
      }
    },

    setArtist(state, key){
      let room = state.screens.room;

      room.artist = key;
    },

    clickBack(state){
      state.back++;
    },

    zoomIn(state){
      state.zoomIn++;
    },

    zoomOut(state){
      state.zoomOut++
    },

    setTransition(state, transition) {
      state.transition = transition;
    },

    startTransition(state){
      state.startTransition++;
    },

    endTransition(state){
      state.endTransition++;
    },

    enterGallery(state){
      console.warn('enterGallery');
      state.enterGallery++;
    },

    unloadGallery(state){
      let pano = state.environment.isMobile ?  state.screens.room.gallery.mobile : state.screens.room.gallery.pano;
      state.resources[pano] = null;
      delete state.resources[pano];
    },

    unloadPano(state, artistKey){
      let artist = state.artists.find(a => a.key == artistKey);

      if(!artist) return;
      let pano = state.environment.isMobile ?  artist.mobile : artist.pano;
      state.resources[pano] = null;
      delete state.resources[pano];
    },

    enterRoom(state){
      console.log('ENTER ROOM');
      state.enterRoom++;
    },

    startRoom(state){
      console.log('START ROOM');
      state.startRoom++;
    },

    requestAccelerometer(state){
      state.accelerometerRequest++;
    },

    checkPlatform(state){
      var userAgent = navigator.userAgent;

      if(/Linux/.test(userAgent)){
          state.environment.platformName = "Linux";
          state.environment.isLinux = true;
      }

      if(/Android/.test(userAgent)){
          state.environment.platformName = "Android";
          state.environment.isAndroid = true;
      }

      if(/CrOS/.test(userAgent)){
          state.environment.platformName = "ChromeOS";
          state.environment.isChromeOS = true;
      }

      if(/iP[ao]d|iPhone/i.test(userAgent) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)){
          state.environment.platformName = "iOS";
          state.environment.isIOS = true;
      }

      if(/Mac OS/.test(userAgent)){
          state.environment.platformName = "Mac";
          state.environment.isMacOS = true;
      }

      if(/Windows/.test(userAgent)){
          state.environment.platformName = "Windows";
          state.environment.isWindows = true;
      }

      if(state.environment.isWindows || state.environment.isMacOS || state.environment.isLinux){
          state.environment.isDesktop = true;
      }

      if(state.environment.isAndroid || state.environment.isIOS || state.environment.isWebApp){
          state.environment.isMobile = true;
      }
    }

  },
  actions: {},
  modules: {}
});
